/* LAYOUT */
export const LAYOUT_REQUEST = "LAYOUT/LAYOUT_REQUEST";
export const LAYOUT_REQUEST_SUCCESS = "LAYOUT/LAYOUT_REQUEST_SUCCESS";
export const LAYOUT_REQUEST_ERROR = "LAYOUT/LAYOUT_REQUEST_ERROR";
